import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";

import {
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Label,
  Input,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
// import DeleteModal from "components/Common/DeleteModal";

import { getSchemelist } from "store/scheme/actions";
import { getcyclelist } from "store/cycle/actions";
import {
  getAllLabs,
  // getParticipantCount,
} from "store/registration-admin/actions";

import { isEmpty, size } from "lodash";
import DeleteModal from "components/Common/DeleteModal";
import "assets/scss/table.scss";
import moment from "moment";
class SchemeDetailsReport2 extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      idFilter: "",
      nameFilter: "",
      priceFilter: "",
      dateofadditionFilter: "",
      schemes: [], // Initialize schemes as an empty array
      structuredData: [], // Also initialize structuredData
      noofanalytesFilter: "",
      addedbyFilter: "",
      statusFilter: "",
      analytetypeFilter: "",
      SchemeList: [],
      schemeNameDropdownFilter: "",
      selectedSchemeId: "", // Store selected scheme ID
      selectedCycleId: "", // Store selected cycle ID
      addedByDropdownFilter: "",
      analyte: "",
      modal: false,
      // Add these for your modal
      selectedParticipants: [],
      LabModal: false,
      modalSchemeName: "",
      modalOpenedFrom: "other", // ✅ mark other modal types
      AllLabs: [],
      deleteModal: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      schemeFilters: {}, // ✅ holds filters like { scheme12A: "", newww: "" }
      provinceFilter: "",
      cityFilter: "",
      districtFilter: "",
    };
  }
  openParticipantList = schemeName => {
    console.log("Looking for scheme:", schemeName);

    const scheme = this.state.SchemeList.find(
      s => s.name.trim().toLowerCase() === schemeName.trim().toLowerCase()
    );

    console.log("Scheme found:", scheme);

    const selectedParticipants = scheme?.labs || [];

    console.log("Selected participants:", selectedParticipants);

    this.setState({
      selectedParticipants,
      LabModal: true,
      modalSchemeName: schemeName,
    });
  };

  toggleLabModal = () => {
    this.setState(prevState => ({
      LabModal: !prevState.LabModal,
    }));
  };

  componentDidMount() {
    const { user_id } = this.state;
    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    // Call fetchData to fetch AllLabs
    this.fetchData(user_id);

    const { onGetScheme, onGetInstrumentTypeList } = this.props;
    onGetScheme(user_id); // Fetch schemes
    onGetInstrumentTypeList(this.state.user_id);
  }
  fetchData(user_id) {
    const { onGetPendingLabs } = this.props;

    if (onGetPendingLabs) {
      console.log("Calling getAllLabs API with user_id:", user_id);
      onGetPendingLabs(user_id); // Call the action
    } else {
      console.error("onGetPendingLabs action is not available.");
    }
  }

  handleFilterChange = (filterName, e, isScheme = false) => {
    const value = e.target.value;

    if (isScheme) {
      this.setState(prevState => ({
        schemeFilters: {
          ...prevState.schemeFilters,
          [filterName]: value,
        },
      }));
    } else {
      this.setState({ [filterName]: value });
    }
  };
  componentDidUpdate(prevProps) {
    const { AllLabs } = this.props;

    if (prevProps.AllLabs !== AllLabs && Array.isArray(AllLabs)) {
      const regionMap = {};

      AllLabs.forEach(lab => {
        const { province, city, district } = lab;
        const key = `${province}|${city}|${district}`;

        if (!regionMap[key]) {
          regionMap[key] = { province, city, district, schemes: [] };
        }

        (lab.schemes || []).forEach(s => {
          // ✅ Push unique scheme-cycle pairs
          if (
            !regionMap[key].schemes.some(
              item =>
                item.scheme_id === s.scheme_id && item.cycle_id === s.cycle_id
            )
          ) {
            regionMap[key].schemes.push({
              scheme_name: s.scheme_name,
              scheme_id: s.scheme_id,
              cycle_id: s.cycle_id,
              cycle_no: s.cycle_no,
              status: s.cycle_status,
            });
          }

          // ✅ Count once per scheme for scheme-level columns
          regionMap[key][s.scheme_name] =
            (regionMap[key][s.scheme_name] || 0) + 1;

          // ✅ Count once per cycle for cycle-level columns
          const cycleKey = s.cycle_id.toString();
          regionMap[key][cycleKey] = (regionMap[key][cycleKey] || 0) + 1;
        });
      });

      const structuredData = Object.values(regionMap);
      const allSchemes = [
        ...new Set(
          AllLabs.flatMap(l => (l.schemes || []).map(s => s.scheme_name))
        ),
      ];

      this.setState({ structuredData, schemes: allSchemes });
    }
  }
  getCyclesForSelectedScheme() {
    const { selectedSchemeId } = this.state;
    const { AllLabs } = this.props;

    if (!selectedSchemeId) return [];

    const cycles = (AllLabs || [])
      .flatMap(lab => lab.schemes || [])
      .filter(s => s.scheme_id === parseInt(selectedSchemeId))
      .reduce((unique, s) => {
        if (!unique.some(u => u.cycle_id === s.cycle_id)) {
          unique.push({
            cycle_id: s.cycle_id,
            cycle_no: s.cycle_no,
            status: s.cycle_status,
            cycle_label: `${s.cycle_no} (${s.cycle_status})`,
          });
        }
        return unique;
      }, []);

    return cycles;
  }
  getNonSubscribedLabsList(regionRow, selectedSchemeId) {
    const { AllLabs } = this.props;
    if (!selectedSchemeId) return [];

    // 1. Filter labs in this region
    const regionLabs = (AllLabs || []).filter(
      lab =>
        (!regionRow.province || lab.province === regionRow.province) &&
        (!regionRow.city || lab.city === regionRow.city) &&
        (!regionRow.district || lab.district === regionRow.district)
    );
    if (!regionLabs.length) return [];

    // 2. Get all cycles globally for this scheme
    const allSchemeCycles = (AllLabs || [])
      .flatMap(lab => lab.schemes || [])
      .filter(s => parseInt(s.scheme_id) === parseInt(selectedSchemeId));

    if (!allSchemeCycles.length) return [];

    // 3. Determine latest cycle ID
    const latestCycle = allSchemeCycles.reduce((max, s) =>
      parseInt(s.cycle_id) > parseInt(max.cycle_id) ? s : max
    );

    // 4. Labs in latest cycle in this region
    const latestLabs = regionLabs.filter(lab =>
      lab.schemes?.some(
        s =>
          parseInt(s.scheme_id) === parseInt(selectedSchemeId) &&
          parseInt(s.cycle_id) === parseInt(latestCycle.cycle_id)
      )
    );

    // 5. Labs in any previous cycles in this region
    const prevLabs = regionLabs.filter(lab =>
      lab.schemes?.some(
        s =>
          parseInt(s.scheme_id) === parseInt(selectedSchemeId) &&
          parseInt(s.cycle_id) !== parseInt(latestCycle.cycle_id)
      )
    );

    // 6. Return labs in previous cycles but NOT in latest
    const latestIds = new Set(latestLabs.map(lab => lab.id));
    return prevLabs.filter(lab => !latestIds.has(lab.id));
  }

  // Returns the count for Not Subscribed column
  getNonSubscribedCountForRegion(regionRow) {
    const { selectedSchemeId } = this.state;
    if (!selectedSchemeId) return 0;

    try {
      // Get the non-subscribed labs using the region-aware function
      const labs = this.getNonSubscribedLabsList(regionRow, selectedSchemeId);

      // Return the count, or 0 if empty
      return Array.isArray(labs) ? labs.length : 0;
    } catch (err) {
      console.error("Error in getNonSubscribedCountForRegion:", err);
      return 0;
    }
  }

  generateColumns() {
    const { schemes, structuredData, selectedSchemeId, selectedCycleId } =
      this.state;

    const fixedColumns = [
      {
        dataField: "province",
        text: "Province",
        sort: true,
        style: { textAlign: "center" },
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>
            <div style={{ marginTop: "5px" }}>
              <input
                type="text"
                value={this.state.provinceFilter}
                onChange={e => this.handleFilterChange("provinceFilter", e)}
                className="form-control"
                style={{ textAlign: "center", width: "100px", margin: "auto" }}
              />
            </div>
            <div>{column.text}</div>
          </div>
        ),
      },
      {
        dataField: "city",
        text: "City",
        sort: true,
        style: { textAlign: "center" },
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>
            <div style={{ marginTop: "5px" }}>
              <input
                type="text"
                value={this.state.cityFilter}
                onChange={e => this.handleFilterChange("cityFilter", e)}
                className="form-control"
                style={{ textAlign: "center", width: "100px", margin: "auto" }}
              />
            </div>
            <div>{column.text}</div>
          </div>
        ),
      },
      {
        dataField: "district",
        text: "District",
        sort: true,
        style: { textAlign: "center" },
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>
            <div style={{ marginTop: "5px" }}>
              <input
                type="text"
                value={this.state.districtFilter}
                onChange={e => this.handleFilterChange("districtFilter", e)}
                className="form-control"
                style={{ textAlign: "center", width: "100px", margin: "auto" }}
              />
            </div>
            <div>{column.text}</div>
          </div>
        ),
      },
    ];

    // CASE: No scheme selected → show scheme columns
    if (!selectedSchemeId) {
      const dynamicColumns = (schemes || []).map(scheme => {
        return {
          dataField: scheme, // ✅ Use scheme string directly
          text: scheme, // ✅ Display scheme name correctly
          sort: true,
          style: { textAlign: "center" },
          headerStyle: { textAlign: "center", minWidth: "120px" },
          headerFormatter: column => {
            let totalCount = 0;
            structuredData.forEach(row => {
              const count = parseInt(row[scheme], 10);
              if (!isNaN(count)) totalCount += count;
            });

            return (
              <div style={{ textAlign: "center" }}>
                <div style={{ fontWeight: "bold" }}>{column.text}</div>
                <div style={{ fontSize: "12px", color: "#777" }}>
                  Total: {totalCount}
                </div>
              </div>
            );
          },
          formatter: (cell, row) => {
            const count = parseInt(cell, 10);
            if (!count) return <span>--</span>;
            return (
              <span
                style={{ cursor: "pointer", color: "blue" }}
                onClick={() => this.openCountModal(row, scheme)}
              >
                {count}
              </span>
            );
          },
        };
      });

      return [...fixedColumns, ...dynamicColumns];
    }

    // CASE 2: Scheme selected → show cycles + Not Subscribed
    let cycleList = this.getCyclesForSelectedScheme();

    // Sort cycles ascending → older cycles first
    cycleList = cycleList.sort(
      (a, b) => parseInt(a.cycle_no) - parseInt(b.cycle_no)
    );

    const filteredCycles = selectedCycleId
      ? cycleList.filter(c => c.cycle_id === parseInt(selectedCycleId))
      : cycleList;

    // Cycle columns
    const cycleColumns = filteredCycles.map(cycle => {
      let totalCount = 0;
      structuredData.forEach(row => {
        const count = parseInt(row[cycle.cycle_id], 10);
        if (!isNaN(count)) totalCount += count;
      });

      return {
        dataField: `${cycle.cycle_id}`,
        text: `Cycle ${cycle.cycle_no}`,
        sort: true,
        headerStyle: { textAlign: "center", minWidth: "100px" },
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold" }}>{column.text}</div>
            <div style={{ fontSize: "12px", color: "#555" }}>
              Total: {totalCount}
            </div>
          </div>
        ),
        formatter: (cell, row) => {
          const count = parseInt(cell, 10);
          if (!count) return <span>--</span>;
          return (
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() =>
                this.openCountModal(row, selectedSchemeId, cycle.cycle_id)
              }
            >
              {count}
            </span>
          );
        },
      };
    });
    // ✅ Insert new "Not Subscribed" column here
    // Column formatter for table
    const nonSubscribedColumn = {
      dataField: "nonSubscribed",
      text: "Not Subscribed to Latest Cycle",
      sort: true,
      headerStyle: {
        textAlign: "center",
        minWidth: "150px",
        background: "#ffdfdf",
      },
      headerFormatter: () => (
        <div style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>
          Not Subscribed
        </div>
      ),
      formatter: (cell, row) => {
        // Get the latest and previous cycle labs
        const nonSubscribedLabs = this.getNonSubscribedLabsList(
          row,
          this.state.selectedSchemeId
        );

        // If there are no previous labs, show "-"
        if (!nonSubscribedLabs || nonSubscribedLabs.length === 0)
          return <span>-</span>;

        // Show count (either diff if comparison exists, or full previous cycle count if latest is empty)
        const count = nonSubscribedLabs.length;

        return (
          <span
            style={{ color: "red", cursor: "pointer", fontWeight: "bold" }}
            onClick={() =>
              this.openCountModal(
                row,
                this.state.selectedSchemeId,
                "nonSubscribed"
              )
            }
            title="Click to see lab details"
          >
            {count}
          </span>
        );
      },
    };
    // ✅ Insert new "Extra" column here
    // const extraColumn = {
    //   dataField: "comments",
    //   text: "Comments",
    //   sort: false,
    //   headerStyle: {
    //     textAlign: "center",
    //     minWidth: "120px",
    //     background: "#e8f4ff",
    //   },
    //   headerFormatter: () => (
    //     <div style={{ textAlign: "center", fontWeight: "bold", color: "#0056b3" }}>
    //       Comments
    //     </div>
    //   ),
    //   formatter: (cell, row) => {
    //     const { selectedSchemeId } = this.state;
    //     const { organization_name } = this.props.match.params; // ✅ Get from route params (React Router v5)
    //     if (!selectedSchemeId || !organization_name) return "--";

    //     // ✅ Build the correct URL
    //     const commentPageUrl = `/${organization_name}/commentscyclerenew?scheme=${selectedSchemeId}&province=${encodeURIComponent(
    //       row.province || "all"
    //     )}&district=${encodeURIComponent(row.district || "all")}&city=${encodeURIComponent(
    //       row.city || "all"
    //     )}`;

    //     return (
    //       <div style={{ textAlign: "center" }}>
    //         <Link
    //           to={commentPageUrl}
    //           title="View Comments"
    //           style={{ color: "#0056b3" }}
    //         >
    //           <i
    //             className="fas fa-comments"
    //             style={{
    //               fontSize: "18px",
    //               cursor: "pointer",
    //               transition: "0.3s",
    //             }}
    //             onMouseOver={(e) => (e.currentTarget.style.color = "#007bff")}
    //             onMouseOut={(e) => (e.currentTarget.style.color = "#0056b3")}
    //           />
    //         </Link>
    //       </div>
    //     );
    //   },
    // };

    return [...fixedColumns, ...cycleColumns, nonSubscribedColumn];
  }
  // getNonSubscribedLabs = regionRow => {
  //   const { AllLabs } = this.props; // only get AllLabs from props
  //   const { selectedSchemeId } = this.state;

  //   if (!selectedSchemeId) return [];

  //   // Get cycles for the selected scheme
  //   const cycleList = this.getCyclesForSelectedScheme();
  //   if (!cycleList || cycleList.length < 2) return [];

  //   const sortedCycles = [...cycleList].sort(
  //     (a, b) => parseInt(a.cycle_no) - parseInt(b.cycle_no)
  //   );
  //   const previousCycle = sortedCycles[sortedCycles.length - 2];
  //   const latestCycle = sortedCycles[sortedCycles.length - 1];

  //   // Labs in this region
  //   const regionLabs = (AllLabs || []).filter(
  //     lab =>
  //       lab.province === regionRow.province &&
  //       lab.city === regionRow.city &&
  //       lab.district === regionRow.district
  //   );

  //   // Labs in previous cycle
  //   const prevLabs = regionLabs.filter(lab =>
  //     lab.schemes?.some(
  //       s => s.scheme_id === schemeId && s.cycle_id === previousCycle.cycle_id
  //     )
  //   );

  //   // Labs in latest cycle
  //   const latestLabs = regionLabs.filter(lab =>
  //     lab.schemes?.some(
  //       s => s.scheme_id === schemeId && s.cycle_id === latestCycle.cycle_id
  //     )
  //   );

  //   // Labs in prev but NOT in latest
  //   return prevLabs.filter(
  //     pLab => !latestLabs.some(lLab => lLab.id === pLab.id)
  //   );
  // };

  getCycleLabs = (row, schemeId, cycleId) => {
    const { AllLabs } = this.props;

    return (AllLabs || []).filter(
      lab =>
        lab.province === row.province &&
        lab.city === row.city &&
        lab.district === row.district &&
        lab.schemes?.some(
          s =>
            s.scheme_id === parseInt(schemeId) &&
            s.cycle_id === parseInt(cycleId)
        )
    );
  };

  openCountModal = (row, schemeIdOrName, cycleId = null) => {
    const { AllLabs, SchemeList } = this.props;

    // 🟥 Case 1: Handle "Not Subscribed" click
    if (cycleId === "nonSubscribed") {
      const { selectedSchemeId } = this.state;
      const nonSubscribedLabs = this.getNonSubscribedLabsList(
        row,
        parseInt(selectedSchemeId)
      );

      this.setState({
        selectedParticipants: nonSubscribedLabs,
        modalProvince: row.province,
        modalCity: row.city,
        modalDistrict: row.district,
        modalSchemeName:
          SchemeList.find(s => s.id === parseInt(selectedSchemeId))?.name || "",
        LabModal: true,
        modalOpenedFrom: "nonSubscribed", // ✅ track source of modal
      });
      return;
    }

    // 🟦 Case 2: Determine schemeId
    let schemeId;
    let schemeName = "";

    if (isNaN(schemeIdOrName)) {
      const match = SchemeList.find(
        s => s.name.trim().toLowerCase() === schemeIdOrName.trim().toLowerCase()
      );
      schemeId = match ? match.id : null;
      schemeName = match ? match.name : schemeIdOrName;
    } else {
      schemeId = parseInt(schemeIdOrName);
      schemeName =
        SchemeList.find(s => s.id === schemeId)?.name || schemeIdOrName;
    }

    cycleId = cycleId ? parseInt(cycleId) : null;

    // 🟩 Case 3: Filter labs by region
    let filteredLabs = (AllLabs || []).filter(
      lab =>
        lab.province === row.province &&
        lab.city === row.city &&
        lab.district === row.district
    );

    // 🔹 If no scheme selected (top-level scheme count)
    if (!this.state.selectedSchemeId) {
      filteredLabs = filteredLabs.filter(lab =>
        lab.schemes?.some(
          s =>
            s.scheme_name.trim().toLowerCase() ===
            schemeIdOrName.trim().toLowerCase()
        )
      );
    } else if (schemeId) {
      // 🔹 If scheme is selected
      filteredLabs = filteredLabs.filter(lab =>
        lab.schemes?.some(s => s.scheme_id === schemeId)
      );
    }

    // 🔹 If cycle is clicked
    if (cycleId) {
      filteredLabs = filteredLabs.filter(lab =>
        lab.schemes?.some(
          s => s.scheme_id === schemeId && s.cycle_id === cycleId
        )
      );
    }

    this.setState({
      selectedParticipants: filteredLabs,
      modalProvince: row.province,
      modalCity: row.city,
      modalDistrict: row.district,
      modalSchemeName: schemeName,
      LabModal: true,
    });
  };

  generateSchemeColumns() {
    const { schemes } = this.state;

    if (!schemes || !Array.isArray(schemes)) {
      return []; // Return an empty array if schemes is not valid
    }

    return schemes.map(scheme => ({
      dataField: scheme,
      text: scheme,
      sort: true,
      style: { textAlign: "center" },
    }));
  }
  fetchData(user_id) {
    const { onGetPendingLabs } = this.props;

    if (onGetPendingLabs) onGetPendingLabs(user_id);
  }

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  render() {
    const { SchemeList, onGetInstrumentTypeList } = this.props;
    const {
      provinceFilter = "",
      cityFilter = "",
      districtFilter = "",
      schemeFilters = {},
      structuredData = [],
    } = this.state;

    // Loading state if structuredData is empty
    if (!structuredData || structuredData.length === 0) {
      return <div>Loading...</div>;
    }

    // Generate columns dynamically
    const allColumns = this.generateColumns();

    console.log("Structured Data:", structuredData);
    console.log("Generated Columns:", allColumns);

    // Filter data based on filters
    // 🧩 Filter data based on province, city, district, scheme & cycle
    // 🧩 Filter data based on province, city, district, scheme & cycle
    const filteredData = structuredData.filter(entry => {
      const province = entry.province?.toLowerCase() || "";
      const city = entry.city?.toLowerCase() || "";
      const district = entry.district?.toLowerCase() || "";

      const matchesProvince = province.includes(
        this.state.provinceFilter.toLowerCase()
      );
      const matchesCity = city.includes(this.state.cityFilter.toLowerCase());
      const matchesDistrict = district.includes(
        this.state.districtFilter.toLowerCase()
      );

      const selectedSchemeId = parseInt(this.state.selectedSchemeId);
      const selectedCycleId = parseInt(this.state.selectedCycleId);

      // ✅ If no scheme selected → show all
      if (!selectedSchemeId) {
        return matchesProvince && matchesCity && matchesDistrict;
      }

      // ✅ Scheme filter: this region must contain at least one lab
      // that has the selected scheme (from AllLabs)
      const labsForThisRegion = (this.props.AllLabs || []).filter(lab => {
        return (
          lab.province === entry.province &&
          lab.city === entry.city &&
          lab.district === entry.district
        );
      });

      // ✅ Check if any lab in this region has the selected scheme
      const hasScheme = labsForThisRegion.some(lab =>
        lab.schemes?.some(s => s.scheme_id === selectedSchemeId)
      );

      // ✅ If a cycle is also selected, ensure one lab in region has that specific cycle
      const hasCycle = !selectedCycleId
        ? true
        : labsForThisRegion.some(lab =>
            lab.schemes?.some(
              s =>
                s.scheme_id === selectedSchemeId &&
                s.cycle_id === selectedCycleId
            )
          );

      return (
        matchesProvince &&
        matchesCity &&
        matchesDistrict &&
        hasScheme &&
        hasCycle
      );
    });

    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length,
      custom: true,
    };
    const defaultSorted = [{ dataField: "province", order: "asc" }];
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Scheme List | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
              title="Scheme Details"
              breadcrumbItem="Scheme Details"
            />
            <Row className="justify-content-center">
              <Col lg="10">
                <Card>
                  <Row className="mb-3">
                    {/* ✅ Existing Scheme dropdown */}
                    <Col
                      md={4}
                      style={{ paddingLeft: "50px", paddingTop: "10px" }}
                    >
                      <Label>Select Scheme</Label>
                      <Input
                        type="select"
                        value={this.state.selectedSchemeId}
                        onChange={e => {
                          const schemeId = e.target.value;
                          this.setState({
                            selectedSchemeId: schemeId,
                            selectedCycleId: "",
                          });
                        }}
                      >
                        <option value="">All Schemes</option>
                        {this.props.SchemeList.map((scheme, idx) => (
                          <option key={idx} value={scheme.id}>
                            {scheme.name}
                          </option>
                        ))}
                      </Input>
                    </Col>
                    {this.state.selectedSchemeId && (
                      <Col md={4} style={{ paddingTop: "10px" }}>
                        <Label>Select Cycle</Label>
                        {(() => {
                          const relevantCycles = (this.props.AllLabs || [])
                            .flatMap(lab => lab.schemes || [])
                            .filter(
                              s =>
                                s.scheme_id ===
                                parseInt(this.state.selectedSchemeId)
                            )
                            .reduce((unique, s) => {
                              if (!unique.some(u => u.id === s.cycle_id)) {
                                unique.push({
                                  id: s.cycle_id,
                                  cycle_no: s.cycle_no,
                                  status: s.cycle_status,
                                  scheme_name: s.scheme_name,
                                });
                              }
                              return unique;
                            }, []);

                          if (relevantCycles.length === 0) {
                            return (
                              <div style={{ marginTop: "5px", color: "#888" }}>
                                No cycles available for this scheme.
                              </div>
                            );
                          }

                          return (
                            <Input
                              type="select"
                              value={this.state.selectedCycleId}
                              onChange={e =>
                                this.setState({
                                  selectedCycleId: e.target.value,
                                })
                              }
                            >
                              <option value="">All Cycles</option>
                              {relevantCycles.map(cycle => (
                                <option key={cycle.id} value={cycle.id}>
                                  {cycle.scheme_name} - {cycle.cycle_no} (
                                  {cycle.status})
                                </option>
                              ))}
                            </Input>
                          );
                        })()}
                      </Col>
                    )}
                  </Row>

                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory({
                        sizePerPage: 50,
                        totalSize: filteredData.length,
                        showTotal: true,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={filteredData}
                          columns={allColumns}
                          search
                        >
                          {toolkitProps => (
                            <div>
                              <div className="table-responsive">
                                <BootstrapTable
                                  bootstrap4
                                  bordered
                                  hover
                                  striped
                                  headerWrapperClasses="table-light"
                                  defaultSorted={defaultSorted}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  filter={filterFactory()}
                                />
                              </div>

                              <Modal
                                isOpen={this.state.LabModal}
                                toggle={this.toggleLabModal}
                              >
                                <ModalHeader
                                  toggle={this.toggleLabModal}
                                  tag="h4"
                                >
                                  Participants in {this.state.modalTitle} -{" "}
                                  {this.state.modalProvince},{" "}
                                  {this.state.modalDistrict},{" "}
                                  {this.state.modalCity}
                                  {this.state.modalSchemeName && (
                                    <strong>
                                      {" "}
                                      ({this.state.modalSchemeName})
                                    </strong>
                                  )}
                                </ModalHeader>

                                <ModalBody>
                                  {this.state.selectedParticipants.length ===
                                  0 ? (
                                    <p className="text-center text-muted">
                                      No participants found in this location.
                                    </p>
                                  ) : (
                                    <div className="table-responsive">
                                      <table className="table table-bordered table-hover align-middle">
                                        <thead className="table-light">
                                          <tr>
                                            <th style={{ textAlign: "center" }}>
                                              #
                                            </th>
                                            <th style={{ textAlign: "center" }}>
                                              Participant Name
                                            </th>
                                            
                                            {this.state.modalOpenedFrom ===
                                              "nonSubscribed" && (
                                              <th
                                                style={{ textAlign: "center" }}
                                              >
                                                Comments
                                              </th>
                                            )}
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.selectedParticipants.map(
                                            (participant, idx) => {
                                              // ✅ Build link exactly like before
                                              const { selectedSchemeId } =
                                                this.state;
                                              const { organization_name } =
                                                this.props.match.params;
                                              const commentPageUrl = `/${organization_name}/csrcommentscyclerenew?participant_id=${participant.id}&scheme=${selectedSchemeId}&province=${encodeURIComponent(
  this.state.modalProvince || "all"
)}&district=${encodeURIComponent(
  this.state.modalDistrict || "all"
)}&city=${encodeURIComponent(this.state.modalCity || "all")}`;


                                              return (
                                                <tr key={idx}>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {idx + 1}
                                                  </td>
                                                  <td>
                                                    {participant.name ||
                                                      "Unnamed Lab"}
                                                  </td>
                                                 
                                                  {this.state
                                                    .modalOpenedFrom ===
                                                    "nonSubscribed" && (
                                                    <td
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <Link
                                                        to={commentPageUrl}
                                                        title="View Comments"
                                                        style={{
                                                          color: "#0056b3",
                                                        }}
                                                      >
                                                        <i
                                                          className="fas fa-comments"
                                                          style={{
                                                            fontSize: "18px",
                                                            cursor: "pointer",
                                                            transition: "0.3s",
                                                          }}
                                                          onMouseOver={e =>
                                                            (e.currentTarget.style.color =
                                                              "#007bff")
                                                          }
                                                          onMouseOut={e =>
                                                            (e.currentTarget.style.color =
                                                              "#0056b3")
                                                          }
                                                        />
                                                      </Link>
                                                    </td>
                                                  )}
                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </ModalBody>
                              </Modal>

                              <PaginationListStandalone {...paginationProps} />
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

SchemeDetailsReport2.propTypes = {
  match: PropTypes.object,
  AllLabs: PropTypes.array,
  SchemeList: PropTypes.array,
  className: PropTypes.any,
  createInstrumentType: PropTypes.array,
  onGetScheme: PropTypes.func,
  onGetPendingLabs: PropTypes.func,
  onGetInstrumentTypeList: PropTypes.func,
  CycleList: PropTypes.array,
};

const mapStateToProps = state => {
  console.log("SchemeDetailsReport mapStateToProps state:", state);

  // Check if the required slices exist in the state
  if (!state.SchemeList || !state.registrationAdmin) {
    console.error("Required slices missing from Redux state");
    return {
      SchemeList: [],
      AllLabs: [],
    };
  }

  // Extract required properties with fallback to default values
  const SchemeList = state.SchemeList.SchemeList || [];
  const AllLabs = state.registrationAdmin.AllLabs || [];
  const CycleList = state.CycleList?.CycleList || []; // ✅ add this line

  // Logging for debugging purposes
  console.log("SchemeDetailsReport mapStateToProps - SchemeList:", SchemeList);
  console.log("SchemeDetailsReport mapStateToProps - AllLabs:", AllLabs);

  return {
    SchemeList,
    AllLabs,
    CycleList,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetScheme: id => dispatch(getSchemelist(id)),
  onGetPendingLabs: user_id => dispatch(getAllLabs(user_id)),
  onGetInstrumentTypeList: id => dispatch(getcyclelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SchemeDetailsReport2));
